import { render, staticRenderFns } from "./lists-test.vue?vue&type=template&id=aad0e646&scoped=true"
import script from "./lists-test.vue?vue&type=script&lang=ts"
export * from "./lists-test.vue?vue&type=script&lang=ts"
import style0 from "./lists-test.vue?vue&type=style&index=0&id=aad0e646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad0e646",
  null
  
)

export default component.exports